import { useCallback, useEffect, useState } from "react"
import * as S from "./styled"

import Header from "../../components/Header"
import Footer from "../../components/Footer"
import Container from "../../components/Container"
import EventCard from "../../components/EventCard"

import { Api } from "../../api"
import { parseList } from "../../utils/tb/parseList"
import getStore from "../../store"
import { DotLottieReact } from "@lottiefiles/dotlottie-react"
import loadingAnimation from "../../assets/animations/loading"
import { useNavigate } from "react-router-dom"
import { TOrganizer } from "../../utils/@types/data/organizer"

import { CalendarX } from "lucide-react"

const EventSelect = () => {
  const store = getStore()
  const navigate = useNavigate()

  const [loading, setLoading] = useState(true)
  const [list, setList] = useState<any[]>([])

  const [organizerData, setOrganizerData] = useState<TOrganizer>()

  const getData = useCallback(async () => {
    setLoading(true)

    const events = await Api.get.events({})

    if (events.ok) {
      if (events.data.events && events.data.organizer) {
        setOrganizerData(events.data.organizer)
        const parsed = parseList.eventMinToEventCard(events.data.events)

        if (parsed.length > 1) setList(parsed)
        else if (parsed.length === 1) {
          try {
            const req = await Api.get.eventInfo({ eventId: parsed[0].id })

            if (req.ok) {
              const eventString = JSON.stringify(req.data)
              sessionStorage.setItem("event", eventString)
              store.controllers.event.setData(req.data)

              navigate("/", { state: { fromSelect: true } })
            } else {
              alert(
                "Houve um erro ao selecionar o evento. Tente novamente mais tarde",
              )
            }
          } catch (error) {
            alert(
              "Houve um erro ao selecionar o evento. Tente novamente mais tarde",
            )
          }
        }
      } else {
        const message =
          "Houve um erro ao carregar as informações. Tente novamente mais tarde"
        alert(message)
      }
    } else {
      alert(events.error)
    }

    setLoading(false)
  }, [store.controllers.event, navigate])

  useEffect(() => {
    localStorage.removeItem("event")
    sessionStorage.removeItem("event")
    getData()
  }, [getData])

  return (
    <S.Page>
      <Header customData={organizerData} hideLogo />

      <Container fullHeight={true}>
        <S.Main>
          <S.HeaderArea>
            <S.PageTitle>Eventos</S.PageTitle>
            <S.PageSubtitle>
              Escolha um evento para comprar ingressos
            </S.PageSubtitle>
          </S.HeaderArea>

          {loading ? (
            <S.LoadingWrapper>
              <DotLottieReact
                data={loadingAnimation}
                loop
                autoplay
                width={"100%"}
              />
            </S.LoadingWrapper>
          ) : list.length === 0 ? (
            <S.EmptyState role="status" aria-live="polite">
              <S.EmptyIllustration aria-hidden="true">
                <CalendarX />
              </S.EmptyIllustration>
              <S.EmptyTitle>Nenhum evento disponível no momento</S.EmptyTitle>
              <S.EmptyText>
                Volte em breve — novos eventos aparecem por aqui.
              </S.EmptyText>
            </S.EmptyState>
          ) : (
            <S.List>
              {list.map((ticket, k) => (
                <EventCard k={k} key={ticket.id ?? k} data={ticket} />
              ))}
            </S.List>
          )}
        </S.Main>
      </Container>

      <Footer customData={organizerData} variant="minimal" />
    </S.Page>
  )
}

export default EventSelect
